import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TooltipContainer } from './tooltip-container.component';
import { Tooltip } from './tooltip.directive';
import { OverlayModule } from '@angular/cdk/overlay';

export { Tooltip } from './tooltip.directive';
export { TooltipContainer } from './tooltip-container.component';

@NgModule({
  declarations: [
    TooltipContainer,
    Tooltip,
  ],
  exports: [
    TooltipContainer,
    Tooltip,
  ],
  imports: [
    CommonModule,
    OverlayModule
  ],
  entryComponents: [
    TooltipContainer
  ]
})
export class TooltipModule { }
